import store from '../store'
import getSettings from "@/api/settings/getSettings";
import getDoctors from "@/api/settings/getDoctors";
import getSliders from "@/api/settings/getSliders";
import getClinics from "@/api/settings/getClinics";
import i18n from "@/i18n";
import moment from 'moment';
import 'moment/locale/uk';
import 'moment/locale/ru';

const boot = async function () {
    let getters = store.getters

    if(getters.language){
        let momentLocale = getters.language === 'ua' ? 'uk' : 'ru'
        moment.locale(momentLocale);
        i18n.locale = getters.language
    }

    if (!getters.settings.settings) {
        let res = await getSettings();
        store.dispatch('getSettings', res)

    }

    if (!getters.settings.doctors) {
        let res = await getDoctors({});

        store.dispatch('getDoctors', res)
    }

    if (!getters.settings.sliders) {
        let res = await getSliders();

        store.dispatch('getSliders', res)
    }

    if (!getters.settings.clinics) {
        let res = await getClinics();

        store.dispatch('getClinics', res)
    }

}

export default boot

